export const APP_URL = "https://ub.viyume.com";
export const API_URL = "https://web-api.viyume.com/mail/send-mail-ub";
export const RECAPTCHA_KEY = "6LfhtpYrAAAAAOZCO3Lt9l9ZXkXnf-cnyF9oIdTJ";